import { formatBytes, ImagesViewer as SharedImagesViewer } from '@zg-rentals/satellite-components';
import { useAuth } from '@zg-rentals/auth-comet';
import useModal from '../../hooks/useModal';
import stringUtils from '../../utils/stringUtils';
import type { AttachmentsForMessage } from '../MessageAttachments';
import {
  emitIrenePreviewAttachmentsEvent,
  IRENE_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID,
} from '../../constants/clickstreamEvents/attachment';

export type Props = {
  imageAttachments: AttachmentsForMessage;
  selectedImageIndex: number;
};

const ImagesViewer = ({ imageAttachments, selectedImageIndex }: Props) => {
  const { user } = useAuth();
  const { clearModal } = useModal();

  const handlePreviewAttachmentClick = () => {
    emitIrenePreviewAttachmentsEvent(user);
  };

  return (
    <SharedImagesViewer
      imageAttachments={imageAttachments}
      selectedImageIndex={selectedImageIndex}
      onClose={clearModal}
      onPreviewAttachmentClick={handlePreviewAttachmentClick}
      previewAttachmentEventId={IRENE_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID}
      formatFileName={stringUtils.capitalize}
      formatFileSize={formatBytes}
    />
  );
};

export default ImagesViewer;
